import { useMemo } from 'react';
import { AppRoutes } from 'src/types';
import { convertConversationIdToSlug } from 'src/utils';
import {
  DEFAULT_CHAT_ID,
  FIRST_COMPARING_CONV_PARAM,
  SECOND_COMPARE_MODEL_PARAM,
} from 'src/constants';
import {
  useChatHistory,
  useConversationParams,
  useQueryParams,
} from 'src/hooks';
import { useLocation } from 'react-router-dom';

interface UseConversationLinkParams {
  conversationId?: string | null;
  documentId?: string | null;
  linkedConversationId?: string | null;
}

// (irina) if we pass conversation_id or document, it will use that value,
// otherwise it will use the value from the searchParams
export const useConversationLink = ({
  conversationId,
  linkedConversationId,
  documentId,
}: UseConversationLinkParams) => {
  const { currentConversationId } = useConversationParams();
  const { searchParams } = useQueryParams();
  const { isNinjaRetired } = useChatHistory();
  const { pathname } = useLocation();
  const isChatHistory = pathname === AppRoutes.CHAT_HISTORY;

  const { editor: documentFromSearchParams } = searchParams;

  const conversationSearchParam = conversationId
    ? convertConversationIdToSlug(conversationId)
    : currentConversationId !== DEFAULT_CHAT_ID
      ? convertConversationIdToSlug(currentConversationId)
      : null;

  const documentSearchParam = documentId || documentFromSearchParams;

  const comparedQueryString =
    linkedConversationId && conversationId
      ? `compare=true&${FIRST_COMPARING_CONV_PARAM}=${convertConversationIdToSlug(conversationId)}&${SECOND_COMPARE_MODEL_PARAM}=${convertConversationIdToSlug(linkedConversationId)}`
      : '';

  const queryParamsString = [
    conversationSearchParam && !comparedQueryString
      ? `conv=${conversationSearchParam}`
      : '',
    documentSearchParam ? `editor=${documentSearchParam}` : '',
    comparedQueryString ? comparedQueryString : '',
  ]
    .filter((item) => item)
    .join('&');

  const linkTo = useMemo(
    () =>
      `${!(isNinjaRetired && isChatHistory) ? AppRoutes.HOME : AppRoutes.CHAT_HISTORY}${queryParamsString ? `?${queryParamsString}` : ''}`,
    [queryParamsString, isNinjaRetired, isChatHistory],
  );

  return useMemo(
    () => ({
      linkTo,
    }),
    [linkTo],
  );
};
